import React from 'react';
import './NgIfNgFor.scss';

const NgIfNgFor = () => {
  return (
    <div className="main-right-side-section">
      <div className="ngforif-main-section">
        <section>
          <div className="ngforif-section-1">
            <div className="ngforif-section-1-inner">
              <p>*Ng-For - *Ng-If</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

NgIfNgFor.propTypes = {};

NgIfNgFor.defaultProps = {};

export default NgIfNgFor;
